// extracted by mini-css-extract-plugin
module.exports = {"apply":"apply--1CKlr","btns":"btns--1-XP5","saveBtn":"saveBtn--3xCKE","boxTitle":"boxTitle--2sNBr","info":"info--3drPW","high":"high--3IKfi","editor":"editor--3Izui"};